import { h, ComponentType, JSX, Ref } from "preact";

import classname from "../../../foundation/utils/classname";
import IconProps from "../Icons/IconProps";

import styles from "./OnlyIconButton.module.css";

type NativeButtonProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "icon" | "children">;

enum Variant {
    Default = "default",
    Ninja = "ninja"
}

interface Props extends NativeButtonProps {
    buttonRef?: Ref<HTMLButtonElement>;
    variant?: Variant;
    selected?: boolean;
    active?: boolean;
    activated?: boolean;
    icon: ComponentType<IconProps>;
}

function OnlyIconButton({
    class: cssClass,
    buttonRef,
    variant = Variant.Default,
    selected = false,
    active = false,
    activated = false,
    icon: Icon,
    ...nativeButtonProps
}: Props) {
    return (
        <button
            {...nativeButtonProps}
            ref={buttonRef}
            class={classname(styles.onlyIconButton, cssClass, {
                [styles.ninja]: variant === Variant.Ninja,
                [styles.selected]: selected,
                [styles.active]: active,
                [styles.activated]: activated
            })}>
            <Icon/>
        </button>
    );
}

export default OnlyIconButton;
export {
    Props as OnlyIconButtonProps,
    Variant as OnlyIconButtonVariant
};
